// import React, { useState } from 'react';
// import moment from 'moment';
// import DefaultButton from '../buttons/defaultButton';
// import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// // DateFilter Component
// const DateFilter = ({ isWeek, day, currentDate, onPrevPress, onNextPress, loading = false ,noPadding}) => {
//     const [date, setDate] = useState(new Date());

//     // Get Week Range
//     const getWeekRange = (value) => {
//         const today = moment();
//         const date = moment(value);
//         const currentWeekEnd = today.endOf('isoWeek');
//         if (date.isAfter(currentWeekEnd, 'day')) {
//             return;
//         }
//         const startOfWeek = date.isoWeekday() === 1 ? date.format('MMM Do, YY') : date.startOf('isoWeek').format('MMM Do, YY');
//         const endOfWeek = date.endOf('isoWeek').format('MMM Do, YY');
//         return `${startOfWeek} - ${endOfWeek}`;
//     };

//     // Get Month Range
//     const getMonthRange = (value) => {
//         const today = moment();
//         const date = moment(value);
//         const currentMonthEnd = today.endOf('month');
//         if (date.isAfter(currentMonthEnd, 'day')) {
//             return;
//         }
//         const startOfMonth = date.startOf('month').format('MMM Do, YY');
//         const endOfMonth = date.endOf('month').format('MMM Do, YY');
//         return `${startOfMonth} - ${endOfMonth}`;
//     };

//     return (
//         <div className={`flex justify-between items-center bg-light rounded-md  min-w-60 ${noPadding?'p-1':'p-2'}`}>
//             {/* Left Arrow */}
//             <DefaultButton
//                 variant='secondary'
//                 classnames={"bg-white"}
//                 onClick={onPrevPress}
//                 icon={<FaChevronLeft />}
//             />

//             {/* Date Range */}
//             <p style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}>
//                 <div style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
//                     <span className='font-bold text-md'>
//                         {day ? moment(currentDate).format("MMM DD") : isWeek ? getWeekRange(currentDate) : getMonthRange(currentDate)}
//                     </span>
//                 </div>
//             </p>

//             {/* Right Arrow */}
//             <DefaultButton
//                 classnames={"bg-white"}
//                 variant='secondary'
//                 onClick={onNextPress}
//                 icon={<FaChevronRight />}
//             />
//         </div>
//     );
// };


// export default DateFilter;


import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
import moment from "moment";

const DateFilter = ({ currentDate, onPrevPress, onNextPress }) => {
  return (
    <div className="flex items-center justify-between bg-white rounded-md border border-gray-200 text-[10px]">
      
      {/* Left Arrow */}
      <button
        onClick={onPrevPress}
        className="p-2 hover:text-theme/50"
      >
        <FaChevronLeft className="text-theme" />
      </button>

      {/* Date with Calendar Icon */}
      <div className="flex items-center space-x-2">
        <FaRegCalendarAlt className="text-theme text-xs" />
        <span className="text-indigo-900 font-semibold text-xs">
          {moment(currentDate).format("D MMMM YYYY")}
        </span>
      </div>

      {/* Right Arrow */}
      <button
        onClick={onNextPress}
        className="p-2 hover:text-theme/50"
      >
        <FaChevronRight className="text-theme" />
      </button>
    </div>
  );
};

export default DateFilter;
